var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.distinctErrors && _vm.distinctErrors.length
    ? _c(
        "div",
        {
          ref: "errorList",
          staticClass: "error-container",
          class: { errors: !!this.errorStrings.length, grouped: !_vm.inline }
        },
        [
          _c("assistive-text", { attrs: { value: _vm.ariaText } }),
          _vm._v(" "),
          _vm._l(_vm.distinctErrors, function(error, index) {
            return !_vm.ariaOnly
              ? _c("error2", { key: index, attrs: { "aria-hidden": "true" } }, [
                  _c("span", { domProps: { innerHTML: _vm._s(error) } })
                ])
              : _vm._l(_vm.noFieldErrors, function(error, index) {
                  return _c(
                    "error2",
                    { key: index, attrs: { "aria-hidden": "true" } },
                    [_c("span", { domProps: { innerHTML: _vm._s(error) } })]
                  )
                })
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a1dcbed", { render: render, staticRenderFns: staticRenderFns })
  }
}